/* jshint esnext: true */
import { APP_NAME , $html, $document} from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'Nav';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`,
    MOUSEENTER: `mouseenter.${EVENT_NAMESPACE}`,
    MOUSELEAVE: `mouseleave.${EVENT_NAMESPACE}`,
    CLOSE: `close.Nav`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        // Declaration of properties
        this.hoverEnable = false;
    }

    init() {
        this.$background = $('.js-background');

        // Set events and such
        this.$el.on(EVENT.CLICK,'.js-burger-button',()=>this.toggle());
        this.$el.on(EVENT.CLICK,'.js-close',()=>this.toggle());
        this.$el.on(EVENT.MOUSEENTER,'.js-menu-item-color',(e)=>this.hoverItem(e));
        this.$el.on(EVENT.MOUSELEAVE,'.js-menu-item-color',(e)=>this.resetHover(e));
        $document.on(EVENT.CLOSE,()=>this.close());

    }

    resetHover () {
        TweenMax.to(this.$background, 0.3, {
            css : {
                backgroundColor: 'transparent'
            }
        });
    }

    hoverItem (e){
        if(this.hoverEnable){
            TweenMax.to(this.$background, 0.3, {
                css : {
                    backgroundColor: $(e.currentTarget).data('color')
                }
            });
        }
    }

    toggle() {
        $html.toggleClass('nav-is-open');

        if($html.hasClass('nav-is-open')) {
            setTimeout(()=> {
                this.hoverEnable = true;
            },1600);

            $document.triggerHandler({
                type: 'toggle.Nav',
                option: 'open'
            });

        }else {
            this.hoverEnable = false;

            $document.triggerHandler({
                type: 'toggle.Nav',
                option: 'close'
            });
        }
    }

    close() {
        $html.removeClass('nav-is-open');
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
